export default {
  linux: 'linux',
  mac: 'mac',
  windows: 'windows',
};
